module.exports = __webpack_public_path__ + "img/gb9120_1_p.prt.7d998561.jpg";